import { IAddress, IAddressSuggestions } from './address-api-interface';

const API_KEY = process.env.REACT_APP_GET_ADDRESS_KEY;

const autocomplete = async (term: string): Promise<IAddressSuggestions> => {
  try {
    const response = await fetch(`https://api.getAddress.io/autocomplete/${term}?api-key=${API_KEY}&all=true&top=20`);
    const json = await response.json();
    return json as IAddressSuggestions;
  } catch (error) {
    console.log(error)
    throw error
  }
};

const getFullAddress = async (id: string): Promise<IAddress> => {
  try {
    const response = await fetch(`https://api.getAddress.io//get/${id}?api-key=${API_KEY}`);
    const json = await response.json();
    return json as IAddress;
  } catch (error) {
    console.log(error)
    throw error
  }
};

const AddressApiService = {
  autocomplete,
  getFullAddress,
};

export default AddressApiService;
